import React from "react";
import { useHistory } from "react-router-dom";
import styles from "./BillRow.module.css";
import type { BillStatus, BillType } from "../Bill/Bill";

interface BillRowProps {
  _id: string;
  title: string;
  amount: number;
  grossAmount: number;
  status: BillStatus;
  billType?: BillType;
  companyName?: string;
  createdAt?: string;
  isAdmin?: boolean;
}

const BillRow: React.FC<BillRowProps> = ({
  _id,
  title,
  amount,
  grossAmount,
  status,
  billType,
  companyName,
  createdAt,
  isAdmin = false,
}) => {
  const history = useHistory();

  const statusLabel =
    status === "paid"
      ? "Opłacony"
      : status === "cancelled"
      ? "Anulowany"
      : "Oczekuje";

  const typeLabel =
    billType === "new_offer"
      ? "Nowa publikacja"
      : billType === "extend_period"
      ? "Przedłużenie publikacji"
      : billType === "highlighted"
      ? "Wyróżnienie wizytówki"
      : billType === "recommended"
      ? "Polecana firma"
      : null;

  const detailsPath = isAdmin
    ? `/admin/bills/details/${_id}`
    : `/my-bills/details/${_id}`;

  return (
    <div
      className={styles.Row}
      onClick={() => history.push(detailsPath)}
    >
      <div className={styles.Title}>
        <div>{title}</div>

        {(typeLabel || (isAdmin && companyName)) && (
          <div className={styles.AdminInfo}>
            {typeLabel && <div>{typeLabel}</div>}

            {isAdmin && companyName && (
              <div>{companyName}</div>
            )}
          </div>
        )}
      </div>

      <div className={styles.Amount}>
        {grossAmount.toFixed(2)} PLN
      </div>

      <div className={`${styles.Status} ${styles[status]}`}>
        {statusLabel}
      </div>

      <div className={styles.Date}>
        {createdAt
          ? new Date(createdAt).toLocaleDateString("pl-PL")
          : "-"}
      </div>
    </div>
  );
};

export default BillRow;